export function toSlug(emneknagg) {
  if (emneknagg && typeof emneknagg === 'object') {
    return emneknagg.slug?.current ?? emneknagg.slug
  } else {
    return emneknagg
  }
}

export function jaccardIndex(listA, listB) {
  const setA = new Set(listA)
  const setB = new Set(listB)
  const intersection = new Set([...setA].filter((value) => setB.has(value)))
  const union = new Set([...setA, ...setB])
  return intersection.size / union.size
}

export function sortEmneknagger(emneknagger) {
  return [...emneknagger].sort((a, b) => {
    if (a.prioritering !== b.prioritering) {
      return b.prioritering - a.prioritering
    } else {
      return a.navn > b.navn ? 1 : -1
    }
  })
}

export function addCounts(emneknagger, emneknaggCounts) {
  return emneknagger.map((emneknagg) => ({
    ...emneknagg,
    count: emneknaggCounts[emneknagg.slug] ?? 0,
  }))
}
